"use strict";

define(["dojo/_base/lang"], function (lang) {
    /*
      String values correspond to MATLAB data types
     Numeric values correspond to equivalent Javascript data types
     */

    var ACCEPTABLE_USER_STRINGS = {
        Infinity: {
            PossibleValues: ["inf"],
            StringValue: "Inf",
            NumberValue: Number.POSITIVE_INFINITY,
            NumericValue: Number.MAX_VALUE
        },

        PositiveInfinity: {
            PossibleValues: ["+inf"],
            StringValue: "+Inf",
            NumberValue: Number.POSITIVE_INFINITY,
            NumericValue: Number.MAX_VALUE
        },

        NegativeInfinity: {
            PossibleValues: ["-inf"],
            StringValue: "-Inf",
            NumberValue: Number.NEGATIVE_INFINITY,
            NumericValue: Number.MIN_VALUE
        },

        PositivePi: {
            PossibleValues: ["+pi"],
            StringValue: "+Pi",
            NumberValue: +Math.PI,
            NumericValue: +Math.PI
        },
        NegativePi: {
            PossibleValues: ["-pi"],
            StringValue: "-Pi",
            NumberValue: -Math.PI,
            NumericValue: -Math.PI
        },
        Pi: {
            PossibleValues: ["pi"],
            StringValue: "Pi",
            NumberValue: +Math.PI,
            NumericValue: +Math.PI
        },

        Nan: {
            PossibleValues: ["nan"],
            StringValue: "nan",
            NumberValue: NaN,
            NumericValue: NaN
        }
    };

    var vals = Object.keys(ACCEPTABLE_USER_STRINGS).map(function (key) {
        return ACCEPTABLE_USER_STRINGS[key];
    });

    var isNumber = function isNumber(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
    };

    return {
        /* check if the value is a number */

        isANumber: function isANumber(value) {
            var keys = Object.keys(ACCEPTABLE_USER_STRINGS),
                isMatlabDataType = false;
            keys.forEach(function (USER_STRING) {
                if (typeof value === "string" && ACCEPTABLE_USER_STRINGS[USER_STRING].StringValue.toLowerCase() === value.toLowerCase()) {
                    isMatlabDataType = true;
                }
            });
            if (isMatlabDataType) {
                return true;
            } else {
                return isNumber(value);
            }
        },
        /* Check if the value is a string */
        isAString: function isAString(myString) {
            return typeof myString === 'string' || myString instanceof String;
        },

        /* checks for White Spaces and Tabs */
        hasWhiteSpace: function hasWhiteSpace(value) {
            return (/\s/g.test(value)
            );
        },

        // Consolidated other validation functions related to numbers used in mw-form as well as uicomponents

        //RegEx to find the valid numbers (considered by matlab) with or without +, -, . numbers 
        // also it consider +/-I/inf, valid numbers
        //Valid numbers are numbers like 123, +123, -123, .87, 0.87 or Inf, -Inf.
        validNumberRegex: new RegExp("^[-+]?([0-9]*\\.?[0-9]+|[0-9]+\\.?[0-9]*)([eE][-+]?[0-9]+)?$|^[-+]?[Ii]nf$"),

        //RegEx to find the valid Infinity +/-I/inf
        validInfinityRegex: new RegExp("^[-+]?[Ii]nf$"),

        /**
         * Check if the given string is a valid Number
         * There is no conversion in this method so any number string (javascript) or matlab can be used to validate
         * Valid numbers are numbers like 123, +123, -123, .87, 0.87 or Inf, -Inf.
         *
         * @param userEnteredString the user entered string that was typed in
         * @return Boolean if the value is a number
         :
         */
        isValidNumber: function isValidNumber(userEnteredString) {

            var isValid = !this.isEmpty(userEnteredString) && this.validNumberRegex.test(userEnteredString);
            return isValid;
        },

        /**
         * Converts the given string to a javascript number.
         *
         * If the value is a special user string such as Inf, then the string 'inf' is returned.
         * The string 'inf' is the value required for MATLAB when the user interacts with the widget.
         *
         * If the value is a number, such as "123", then 123 is returned as a double.
         *
         * @param userEnteredString - Any string
         * @param onlyFinite - Bool value to define if conversion required to only Finite value. Default value is false
         *        e.g. string "Infinity" will be converted to Number.POSITIVE_INFINITY if onlyFinite is not true 
         *        but if onlyFinite is true string "Infinity" will be converted to Number.MAX_VALUE 
         *
         * @returns numeric equivalent of user - entered string
         */
        convertValueToNumber: function convertValueToNumber(userEnteredString, onlyFinite) {

            onlyFinite = typeof onlyFinite !== 'undefined' ? onlyFinite : false;
            // Handles converting "Inf", "-Inf", etc...
            // Go through user possible strings

            if (typeof userEnteredString === "string") {
                var currentVal;
                for (currentVal in vals) {

                    // check if the constraint's max equals any of the values
                    var possibleUserStrings = vals[currentVal].PossibleValues;
                    if (possibleUserStrings.indexOf(userEnteredString.toLowerCase()) >= 0) {
                        return onlyFinite ? vals[currentVal].NumericValue : vals[currentVal].NumberValue;
                    }
                }
                if (isNaN(parseFloat(userEnteredString))) {
                    return ACCEPTABLE_USER_STRINGS.Nan.StringValue;
                }
            }

            // otherwise, return what the user entered as a number
            return parseFloat(userEnteredString);
        },

        /**
         * Checks if the given string is valid finite number.
         * There is no conversion in this method so any number string (javascript) or matlab can be used to validate
         *
         * @param value - any number string
         * @returns true or false
         */
        isFiniteValue: function isFiniteValue(value) {
            return this.isValidNumber(value) && !this.validInfinityRegex.test(value) && isFinite(value);
        },

        /**
         * Checks if the given string is valid Infinite value.
         * There is no conversion in this method so any string (javascript) or matlab can be used to validate
         *
         * @param value - any string
         * @returns true or false
         */
        isInfinteValue: function isInfinteValue(value) {

            return this.validInfinityRegex.test(value) || this.isValidNumber(value) && !isFinite(value);
        },

        /**
         * If given string is finite number then returns the precision.
         * Any number string (javascript) or matlab can be used to to get the precision value
         *
         * @param value - Any number string
         * @returns 0 if value is not finite number else precision
         */
        getPrecision: function getPrecision(value) {
            if (!this.isFiniteValue(value)) {
                return 0;
            }
            var e = 1,
                p = 0;
            while (Math.round(value * e) / e !== value) {
                e *= 10;p++;
            }
            return p;
        },

        /**
         * Checks for string is Empty
         * @param value
         * @return {Boolean}
         */
        isEmpty: function isEmpty(value) {
            // summary:
            //      Checks for whitespace
            return (value.trim ? /^\s*$/ : /^$/).test(value); // Boolean
        },

        PositiveInfinity: ACCEPTABLE_USER_STRINGS.PositiveInfinity.NumericValue,
        NegativeInfinity: ACCEPTABLE_USER_STRINGS.NegativeInfinity.NumericValue,
        PositiveInfinityString: ACCEPTABLE_USER_STRINGS.PositiveInfinity.StringValue,
        NegativeInfinityString: ACCEPTABLE_USER_STRINGS.NegativeInfinity.StringValue
    };
});

